import { AppEventDispatcher } from './../../../utils/AppEventDispatcher';
import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { TweenMax, Quint } from 'gsap';
import { EventTypes } from '../../../shared/EventTypes';
import { ChangeDigitalSignatureService } from '../change-digital-signature.service';
import { ChangeDigitalSignature } from '../model/change-digital-signature';
import { ChangeDigitalSignatureEventType } from '../change-digital-signature.event.type';
import { AutenticationService } from '../../../autentication/autentication.service';
import { Auth } from '../../../autentication/Auth';

@Component({
	selector: 'app-reset',
	templateUrl: './reset.component.html',
	styleUrls: ['./reset.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class ResetComponent implements OnInit, OnDestroy {

	@Input() submited: boolean;
	@Input() changeDigitalSignatureData: ChangeDigitalSignature;
	@Output() onSetForm: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();

	formResetSignature: FormGroup;
	inputToResetSignature: any;
	active = false;
	disabled = false;
	private view = '[data-component="reset"]';
	private viewHeight = 0;
	inputClass: string;

	constructor(private formBuilder: FormBuilder,
		private changeDigitalSignatureService: ChangeDigitalSignatureService,
		private autenticationService: AutenticationService) {
		this.formResetSignature = formBuilder.group({
			signatures: this.formBuilder.group({
					signature: ['', [Validators.required]],
					repeatSignature: ['', [Validators.required]],
			}, {validator: this.signatureConfirming}),
		});

	}

	signatureConfirming(c: AbstractControl): { invalid: boolean } {
		if (c.get('signature').value !== c.get('repeatSignature').value) {
				return {invalid: true};
		}
	}

	ngOnInit() {

		AppEventDispatcher.listen( ChangeDigitalSignatureEventType.STEPS.CHANGE_DG_SIGNATURE_RESET, () => {
			this.inputToResetSignature = this.formResetSignature.get(['signatures', 'signature']);
			this.onSetForm.emit(this.formResetSignature);
			this.active = true;
			this.show();
		});

		AppEventDispatcher.listen(ChangeDigitalSignatureEventType.SEND.CHANGE_DG_SIGNATURE_SEND, data => {
			this.send();
		});
	}

	show() {
		const interval = setInterval(() => {

			if ($(this.view).length > 0) {
				const containerHeight = this.getStepHeight();

				this.viewHeight = containerHeight;

				TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut});
				TweenMax.to(this.view, .8, { delay: .4, left: 0, ease: Quint.easeOut});
				TweenMax.to('.buttons', .8, {delay: .8, bottom: 0, ease: Quint.easeOut});

				clearInterval(interval);
			}

		}, 10);
	}

	getStepHeight(): number {
		return $(this.view).outerHeight() + $('.buttons').outerHeight() + 60;
	}

	send() {
		this.submited = true;
		if (this.formResetSignature.valid) {

			this.preload(true);
			this.submited = false;
			this.disabled = true;

			let time = 1;
			const timeLoader = setInterval(() => {
				time++;
			}, 1000);

			this.changeDigitalSignatureService.changeDigitalSignature(this.formResetSignature.value).subscribe(data => {

				if (data.Sucesso) {
					this.changeDigitalSignatureData.success = true;
				} else {
					this.changeDigitalSignatureData.success = false;
				}

				this.changeDigitalSignatureData.message = data.Mensagem;

				this.checkAfterSend(timeLoader, time);
				this.disabled = false;
				this.hide();


			}, error => {
				this.changeDigitalSignatureData.success = false;
				this.changeDigitalSignatureData.message = error.error.Mensagem;
				this.checkAfterSend(timeLoader, time);
				this.disabled = false;
				this.hide();

			});
		}
	}

	keyDownHandler(event: Event) {
		event.preventDefault();
	}

	hide() {
		TweenMax.delayedCall(1, () => {
			AppEventDispatcher.dispatch(ChangeDigitalSignatureEventType.STEPS.CHANGE_DG_SIGNATURE_WARNING, { show: true });

			TweenMax.to(this.view, .8, { delay: .4, left: '-100%', ease: Quint.easeOut, onComplete: () => {
				this.active = false;
			}});
		});
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(ChangeDigitalSignatureEventType.SEND.CHANGE_DG_SIGNATURE_SEND);
		AppEventDispatcher.removeListener( ChangeDigitalSignatureEventType.STEPS.CHANGE_DG_SIGNATURE_RESET);
	}

	setInput(input: string, inputClass: string) {
		this.inputToResetSignature = this.formResetSignature.get(['signatures', input]);
		this.inputClass = inputClass;
	}

	setInputValueFromKeyPad(val) {
		if (this.inputToResetSignature.value.length <= 5) {
			this.inputToResetSignature.setValue(this.inputToResetSignature.value.toString() + val[0].toString());
			$('[data-component="reset"]').find(`.${this.inputClass}`).focus();
		}
	}

	changeToRepeatDigitalSignature() {
		if (this.formResetSignature.get(['signatures', 'signature']).value) {
			$('[data-component="reset"]').find('.repeat-signature').focus();
		}
	}

	checkAfterSend(timeLoader, time) {

		if (time > 3) {
			this.preload(false);
		}	else {
			TweenMax.delayedCall(3 - time, () => {
				this.preload(false);
			});
		}
		clearInterval(timeLoader);
	}

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD,
			{element: '[data-component="reset"] .content', show: active, delay: delay});
	}

	onCorrect() {
		this.inputToResetSignature.setValue('');
	}

	showNumPad() {
		TweenMax.to('[data-component="reset"] .reset-signature [data-component="virtual-num-pad"]', .5, { autoAlpha: 1 });
	}

	hideNumPad(e) {
		if (e.relatedTarget === null || e.relatedTarget.className !== 'keyboard-button') {
			TweenMax.to('[data-component="reset"] .reset-signature [data-component="virtual-num-pad"]', .5, { autoAlpha: 0 });
		}
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/change-digital-signature/reset/reset.component.ts